import { configureStore } from '@reduxjs/toolkit';
import { shortTermHousingRentalsReducer } from './slices/shortTermHousingRentals.slice';

export const store = configureStore({
  reducer: {
    shortTermHousingRentals: shortTermHousingRentalsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
